import {Map} from 'immutable'
import firedux from '../firedux'
import {getState, dispatch} from '../store'

import {
  EXPERT_SESSION_REQUESTS_ENDPOINT,
  ROLES,
  SESSION_REQUEST_STATUSES
} from '../../config/constants'

import getUser from '../getters/user'

import setCurrentExpertSessionRequests from '../actions/set_current_expert_session_requests'
import setNewSessionRequestNotification from '../actions/set_new_session_request_notification'
import showModal from '../actions/show_modal'

const showRequestModal = (sessionRequest, requestKey) => {
  dispatch(showModal({
    type: 'sessionRequest',
    identifier: requestKey,
    props:{sessionRequest}
  }))
}

const showDesktopNotification = (sessionRequest) => {
  dispatch(setNewSessionRequestNotification({
    from: sessionRequest.user,
    to: sessionRequest.expert,
    tag: `sr-${sessionRequest.expert}-${sessionRequest.user}`
  }))
}

const handleSessionRequestSideEffects = (sessionRequests) => {
  Map(sessionRequests).forEach((sessionRequest, requestKey) => {
    if (sessionRequest.status === SESSION_REQUEST_STATUSES.REQUESTED) {
      showRequestModal(sessionRequest, requestKey)
      showDesktopNotification(sessionRequest)

      return false
    }
  })
}

const getUsers = (sessionRequests) => {
  Map(sessionRequests).forEach((req) => getUser(req.user))
}

const onSessionRequest = (snapshot) => {
  if (snapshot.exists()) {
    const sessionRequests = snapshot.val()

    getUsers(sessionRequests)
    dispatch(setCurrentExpertSessionRequests(sessionRequests))

    handleSessionRequestSideEffects(sessionRequests)
  }
}

// const onSessionRequestRemove = (childSnapshot) => {
//   dispatch(removeCurrentExpertSessionRequest)
// }

export const watchCurrentExpertSessionRequests = (uid, role) => {
  if (!(role === ROLES.EXPERT || role === ROLES.AUTHOR)) return
  if (!uid) return

  const ENDPOINT = `${EXPERT_SESSION_REQUESTS_ENDPOINT}/${uid}`

  const ref = firedux.ref.child(ENDPOINT)
  .orderByChild('status').startAt(SESSION_REQUEST_STATUSES.REQUESTED)

  ref.on('value', onSessionRequest)
  // ref.on('child_removed', onSessionRequestRemove)
}

export const unwatchCurrentExpertSessionRequests = () => {
  const uid = getState().getIn(['currentUser', 'uid'])
  const role = getState().getIn(['currentUser', 'role'])

  if (!(role === ROLES.EXPERT || role === ROLES.AUTHOR)) return
  if (!uid) return

  const ENDPOINT = `${EXPERT_SESSION_REQUESTS_ENDPOINT}/${uid}`

  const ref = firedux.ref.child(ENDPOINT)
  .orderByChild('status').equalTo(SESSION_REQUEST_STATUSES.REQUESTED)

  ref.off('value', onSessionRequest)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/current_expert_session_requests.js
 **/